<template>
  <div v-loading="loading" class="app-container">
        <el-timeline>
          <el-timeline-item
            v-for="site in sites"
            :key="site.id"
            :timestamp="parseTime(site.gmtCreate)"
            placement="top"
          >
            <site-card :site="site" :disabled-tip="false" />
          </el-timeline-item>
        </el-timeline>
        <el-empty v-if="sites.length == 0" description="暂无最新收录网站" />
  </div>
</template>
<script setup>
import { ref } from 'vue'

import { listLatestCollect } from '@/api/client/nav'
import { useDefaultClientCategories } from '@/composables/useDefaultClientCategories'

import SiteCard from '@/components/SiteCard'

const setDefaultCategories = useDefaultClientCategories()

const loading = ref(true)
const sites = ref([])

/**
 * 获取最新收录网站
 */
async function getData() {
  loading.value = true
  // 最新收录页没有专属分类接口，使用默认导航分类填充左侧栏
  setDefaultCategories()
  const { data } = await listLatestCollect()
  sites.value = data
  loading.value = false
}

getData()
</script>
